export default __webpack_public_path__ + "static/media/evennumbers_standard.97a0e80a.svg";